export default __webpack_public_path__ + "static/Inter-SemiBold-8c664a8be64bba8f592341236da84cac.woff2";